/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Something the probe worked around rather than failed on.
 */
export enum DiagnosticNote {
    NO_RESOURCE_METADATA_POINTER = 'no_resource_metadata_pointer',
    NO_AUTHORIZATION_SERVERS = 'no_authorization_servers',
    REGISTRATION_ENDPOINT_NOT_HTTPS = 'registration_endpoint_not_https',
    DOCUMENTATION_NOT_HTTPS = 'documentation_not_https',
    NO_TOKEN_AUTH_METHODS = 'no_token_auth_methods',
    CIMD_WITHOUT_S256 = 'cimd_without_s256',
    UNUSABLE_RESOURCE_METADATA_POINTER = 'unusable_resource_metadata_pointer',
    NO_HTTPS_AUTHORIZATION_SERVERS = 'no_https_authorization_servers',
}
